<!--
 * @Author: your name
 * @Date: 2020-03-02 11:22:58
 * @LastEditTime: 2022-07-27 15:49:11
 * @LastEditors: 李嘉辉 LiJiaHui0908
 * @Description: In User Settings Edit
 * @FilePath: /xingmahui_front/src/views/growth/addRecord.vue
 -->

<template>
  <div>
    <span class="gobackBtn" @click="goBack"><img alt="" src="../../../assets/images/home/back.png"></span>
    <div class="wrap">
      <!-- 日期 -->
      <div class="item" @click="alertTimePicker">
        <span class="title">日期</span>
        <div>
          <van-icon class="right_icon" name="arrow"/>
          <span class="con">{{ `${dateText == '' ? '请输入' : dateText} ` }}</span>
        </div>
      </div>
      <!-- 头围 -->
      <div v-show="headShow" class="item" @click="dialogShow('head')">
        <span class="title">头围</span>
        <div>
          <van-icon class="right_icon" name="arrow"/>
          <span class="con">{{ `${headText == '' ? '请输入' : headText} ` }}</span>
        </div>
      </div>
      <!-- 身高 -->
      <div class="item" @click="dialogShow('height')">
        <span class="title">身高</span>
        <div>
          <van-icon class="right_icon" name="arrow"/>
          <span class="con">{{ `${heightText == '' ? '请输入' : heightText} ` }}</span>
        </div>
      </div>
      <!-- 体重 -->
      <div class="item" @click="dialogShow('weight')">
        <span class="title">体重</span>
        <div>
          <van-icon class="right_icon" name="arrow"/>
          <span class="con">{{ `${weightText == '' ? '请输入' : weightText} ` }}</span>
        </div>
      </div>
      <!-- 修改用户名弹窗 -->
      <van-dialog v-model="show" :title="title" cancel-button-color='#D8BD24' confirm-button-color='#D8BD24'
                  confirmButtonText="确认"
                  show-cancel-button @cancel="closeSave" @confirm="confirm">
        <van-cell-group class="usernameclass">
          <van-field v-model="text" :maxlength="userLength" :placeholder="placeholderText" type='number'/>
        </van-cell-group>
      </van-dialog>

      <!-- 时间选择器 -->
      <div class="timeSelectMask">
        <div class="timeSelect">
          <van-datetime-picker v-model="currentDate" :max-date="maxDate" :min-date="minDate" type="date"
                               @cancel="closeTime" @confirm="confirmTime"/>
        </div>
      </div>
    </div>
    <!-- 保存 -->
    <div class="save">
      <span @click="saveUser">保存</span>
    </div>
  </div>

</template>

<style lang="less" scoped>
.public {
  border-bottom: 1px solid #eeeeee;
  height: 44px;
  line-height: 44px;
}

.right_icon {
  width: 5px;
  height: 8px;
  color: #999999;
  margin-top: 16px;
  position: absolute;
  top: 0;
  right: 5px;
}

.font_color {
  color: #666;
  font-size: 13px;
  margin-left: 5px;
}

.gobackBtn {
  width: 26px;
  height: 25px;
  position: fixed;
  top: 6px;
  left: 8px;
  z-index: 100;

  img {
    width: 26px;
    height: 26px;
  }
}

.wrap {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff !important;
  padding: 0 12px;
  overflow: hidden;

  .item {
    position: relative;
    .public;

    .title {
      .font_color;
    }

    .con {
      font-size: 13px;
      color: #999;
      position: absolute;
      top: 0;
      right: 10px;
    }
  }

  /deep/ .van-overlay {
    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  /deep/ .van-dialog {
    width: 245px;
    height: 136px;
    border-radius: 10px;
    background: #fdfdfd;
    opacity: 0.91;

    .van-dialog__header {
      padding: 15px 0 8px 0;
    }

    .van-dialog__content {
      padding-bottom: 13px;
      border: 0;

      .van-cell {
        width: 217px;
        height: 28px;
        background: #fff;
        border-radius: 7px;
        border: 1px solid rgba(218, 218, 218, 1);
        padding: 0;
        padding-left: 10px;
        margin-left: 14px;

        .van-field__control {
          padding-top: 1px;
          caret-color: #333;
          font-size: 12px;
          color: #333;
        }

        input {
          color: #d8bd24;
        }
      }

      .van-cell-group {
        border: 0;
      }

      .van-hairline--top-bottom::after {
        border-width: 0;
      }
    }

    .van-button--large {
      height: 50px;
      line-height: 50px;
    }
  }

  // 时间选择器
  .timeSelectMask {
    width: 100%;
    height: 100%;
    background: @expertColorMask;
    position: fixed;
    top: 0;
    left: 0;
    display: none;

    .timeSelect {
      width: 100%;
      height: 248px;
      position: fixed;
      bottom: 0;
      left: 0;
      display: none;

      /deep/ .van-picker {
        height: 300px;

        .van-picker__toolbar {
          border: 1px solid @expertBorderColor242;
          padding: 0 12px;

          .van-picker__cancel {
            color: #d8bd24;
            font-size: @indexFontSize18;
          }

          .van-picker__confirm {
            color: #d8bd24;
            font-size: @indexFontSize18;
          }
        }

        .van-picker__columns {
          padding: 0 60px 0;
        }
      }
    }
  }
}

.save {
  width: 100%;
  // background: #F6F6F6;
  span {
    display: block;
    width: 248px;
    height: 36px;
    background: linear-gradient(270deg,
    rgba(212, 164, 55, 1) 0%,
    rgba(229, 191, 93, 1) 100%);
    border-radius: 30px;
    margin: 0 auto;
    margin-top: 44px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 36px;
  }
}
</style>

<script>
import API from "@/utils/axiosApi/growApi.js";
import {Debounce, getCookie, is_weixin} from "@/assets/js/common.js";

export default {
  name: "",
  data() {
    return {
      userInfo: '',
      show: false,//弹框状态
      userLength: 10,
      placeholderText: '',
      title: '',
      maxDate: new Date(),
      minDate: new Date(),
      currentDate: new Date(),
      dateText: '',
      heightText: '',
      weightText: '',
      headText: '',
      type: '',
      text: '',
      babyNum: this.$route.query.num,
      babyBir: '',
      babyInfo: [],
      newDate: '',
      headShow: true, // 宝宝出生1年后不显示头围
      babyState: false,
      sourcState: this.$route.query.sourcState,
      dayBith: this.$route.query.bir,
      growth: this.$route.query.growth
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.is_weixin()) {
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          vm.userInfo = JSON.parse(localStorage.getItem("userInfo"))
          API.getBabyInfo({crmId: vm.userInfo.crm_id}, res => {
            if (res.code == "200") {
              vm.babyInfo = res.data
              for (var i = 0; i < vm.babyInfo.length; i++) {
                if (vm.babyNum == vm.babyInfo[i].num) {
                  vm.babySex = vm.babyInfo[i].sex
                  vm.babyBir = vm.babyInfo[i].birth
                  if (vm.babySex == '') {
                    vm.babySex = 'M'
                  }
                }
              }
              if (vm.babyInfo.length == 0) {
                // vm.$router.push({path:'/home',})
                location.href = '/home'
              } else {
                var date = new Date()
                vm.formatDate(date)
                if (vm.babyBir > vm.newDate) {
                  vm.babyState = true
                  vm.newDate = new Date(vm.babyBir).setDate((new Date(vm.babyBir).getDate() - 280))
                  vm.formatDate(vm.newDate)
                  let birthdate2 = vm.newDate.split('-');
                  vm.maxDate = new Date()
                  vm.formatTime(vm.maxDate, "yyyy-MM-dd")
                  vm.minDate = new Date(Number(birthdate2[0]), Number(birthdate2[1]) - 1, Number(birthdate2[2]));
                  // vm.maxDate = new Date(Number(birthdate[0]),Number(birthdate[1])-1,Number(birthdate[2]));
                } else {
                  let birthdate = vm.babyBir.split('-');
                  vm.maxDate = new Date()
                  vm.minDate = new Date(Number(birthdate[0]), Number(birthdate[1]) - 1, Number(birthdate[2]));
                }
              }
            }
          })
        }
      } else {
        vm.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        API.getBabyInfo({crmId: vm.userInfo.crm_id}, res => {
          if (res.code == "200") {
            vm.babyInfo = res.data
            for (var i = 0; i < vm.babyInfo.length; i++) {
              if (vm.babyNum == vm.babyInfo[i].num) {
                vm.babySex = vm.babyInfo[i].sex
                vm.babyBir = vm.babyInfo[i].birth
                if (vm.babySex == '') {
                  vm.babySex = 'M'
                }
              }
            }
            if (vm.babyInfo.length == 0) {
              // vm.$router.push({path:'/home',})
              location.href = '/home'
            } else {
              var date = new Date()
              vm.formatDate(date)
              if (vm.babyBir > vm.newDate) { // 孕期
                vm.babyState = true
                vm.newDate = new Date(vm.babyBir).setDate((new Date(vm.babyBir).getDate() - 280))
                vm.formatDate(vm.newDate)
                var birthdate2 = vm.newDate.split('-');
                vm.maxDate = new Date()
                vm.formatTime(vm.maxDate, "yyyy-MM-dd")
                vm.minDate = new Date(Number(birthdate2[0]), Number(birthdate2[1]) - 1, Number(birthdate2[2]));
                // vm.maxDate = new Date(Number(birthdate[0]),Number(birthdate[1])-1,Number(birthdate[2]));
              } else { // 宝宝出生
                let birthdate = vm.babyBir.split('-');
                vm.maxDate = new Date()
                vm.minDate = new Date(Number(birthdate[0]), Number(birthdate[1]) - 1, Number(birthdate[2]));
              }
            }
          }
        })
      }
    })
  },
  mounted() {
    var shareDataParams = {
      shareLink: this.$http.hostName + "/home",
      shareDesc: '1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。',
      shareTitle: "星妈会",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png"//必须是绝对路径
    }
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    is_weixin, getCookie,
    goBack() {
      if (this.sourcState == 1) {
        this.$router.push({
          path: '/parentingTips?source=home',
          query: {num: this.babyNum, bir: this.dayBith, growth: this.growth, sourceFrom: this.$route.query.sourceFrom}
        });
      } else {
        this.$router.push({
          path: '/growthRecord',
          query: {num: this.babyNum, sourceFrom: this.$route.query.sourceFrom, source: this.$route.query.source}
        });
      }
    },
    // 算出今天和宝宝生日相差的天数
    getDaysBetween: function (dateString1, dateString2) {
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },
    formatDate(inputTime) {
      var date = new Date(inputTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      this.newDate = y + '-' + m + '-' + d;
    },
    // 弹窗显示
    dialogShow(flag) {
      if (flag == 'height') {
        if (this.heightText == '') {
          this.title = '请输入身高'
          if (!this.babyState) {
            this.placeholderText = '身高有效范围：40cm-150cm'
          } else {
            this.placeholderText = '身高有效范围：0mm-550mm'
          }
          this.type = '1'
          this.show = true
        } else {
          this.text = this.heightText
          this.type = '1'
          this.show = true
        }
      } else if (flag == 'weight') {
        if (this.weightText == '') {
          this.title = '请输入体重'
          if (!this.babyState) {
            this.placeholderText = '体重有效范围：0kg-25kg'
          } else {
            this.placeholderText = '体重有效范围：0g-3400g'
          }
          this.type = '2'
          this.show = true
        } else {
          this.text = this.weightText
          this.type = '2'
          this.show = true
        }
      } else if (flag == 'head') {
        if (this.headText == '') {
          this.title = '请输入头围'
          if (!this.babyState) {
            this.placeholderText = '头围有效范围：30cm-55cm'
          } else {
            this.placeholderText = '头围有效范围：0cm-42cm'
          }
          this.type = '3'
          this.show = true
        } else {
          this.text = this.headText
          this.type = '3'
          this.show = true
        }
      }
    },
    //  取消保存
    closeSave() {
      if (this.type == '1') {
        this.heightText = ''
        this.text = ''
      } else if (this.type == '2') {
        this.weightText = ''
        this.text = ''
      } else if (this.type == '3') {
        this.headText = ''
        this.text = ''
      }
    },
    // toast弹窗
    toast(message) {
      this.$toast({
        message: message,
        forbidClick: true,
        duration: 2000,
        context: this
      })
    },
    //  弹窗确认
    confirm() {
      if (this.type == '1') {
        this.heightText = this.text
        // console.error('身高值',this.heightText)
        if (!this.babyState) { // 出生后
          var reg = /^(-?\d+)(\.\d{1,2})?$/
          if (!reg.test(this.heightText)) {
            this.toast('只支持填写小数点后两位')
            this.heightText = ''
            this.text = ''
          } else if (this.heightText < 40 || this.heightText > 150) {
            this.toast('请输入身高的有效范围')
            this.heightText = ''
            this.text = ''
          }
        } else { // 孕期
          var index = this.heightText.indexOf(".")
          if (index > 0) {
            this.toast('请输入整数')
            this.heightText = ''
            this.text = ''
          } else if (this.heightText < 0 || this.heightText > 550) {
            this.toast('请输入身高的有效范围')
            this.heightText = ''
            this.text = ''
          }
        }
        this.text = ''
      } else if (this.type == '2') {
        this.weightText = this.text
        if (!this.babyState) {
          var reg = /^(-?\d+)(\.\d{1,2})?$/
          if (!reg.test(this.weightText)) {
            this.toast('只支持填写小数点后两位')
            this.weightText = ''
            this.text = ''
          } else if (this.weightText < 0 || this.weightText > 25) {
            this.toast('请输入体重的有效范围')
            this.weightText = ''
            this.text = ''
          }
        } else {
          var index = this.weightText.indexOf(".")
          if (index > 0) {
            this.toast('请输入整数')
            this.weightText = ''
            this.text = ''
          } else if (this.weightText < 0 || this.weightText > 3400) {
            this.toast('请输入体重的有效范围')
            this.weightText = ''
            this.text = ''
          }
        }
        this.text = ''
      } else if (this.type == '3') {
        this.headText = this.text
        if (!this.babyState) {
          var reg = /^(-?\d+)(\.\d{1,2})?$/
          if (!reg.test(this.headText)) {
            this.toast('只支持填写小数点后两位')
            this.headText = ''
            this.text = ''
          } else if (this.headText < 30 || this.headText > 55) {
            this.toast('请输入头围的有效范围')
            this.headText = ''
            this.text = ''
          }
        } else {
          var index = this.headText.indexOf(".")
          if (index > 0) {
            this.toast('请输入整数')
            this.headText = ''
            this.text = ''
          } else if (this.headText < 0 || this.headText > 42) {
            this.toast('请输入头围的有效范围')
            this.headText = ''
            this.text = ''
          }
        }
        this.text = ''
      }
    },
    //  保存
    saveUser: Debounce(function () {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
      if (this.dateText == '') {
        this.$toast({
          message: '请输入日期',
          forbidClick: true,
          duration: 2000,
          context: this
        });
      } else if (this.heightText == '') {
        this.$toast({
          message: '请输入身高',
          forbidClick: true,
          duration: 2000,
          context: this
        });
      } else if (this.weightText == '') {
        this.$toast({
          message: '请输入体重',
          forbidClick: true,
          duration: 2000,
          context: this
        });
      } else {
        const headTexts = parseFloat(parseFloat(this.heightText * 10).toFixed(2))
        var isBought = localStorage.getItem('isBought')
        var isFollow = localStorage.getItem('isFollow')
        var userGrade = localStorage.getItem('userInfo')
        
        API.addGrowInfo({is_bought: isBought, user_level: userInfo.level, is_follow: isFollow}, {
          childNumber: this.babyNum,
          crmId: this.userInfo.crm_id,
          head: this.headText,
          height: !this.babyState ? headTexts : this.heightText,
          weight: !this.babyState ? this.weightText * 1000 : this.weightText,
          recordDate: this.dateText,
        }, res => {
          if (res.code == '200') {
            this.setCookie('GrowId', '', -1)
            this.taskFinish()
            sensors.track('SaveGrowthRecord')
          } else {
            this.$toast({
              message: res.message,
              forbidClick: true,
              duration: 2000,
              context: this
            });
          }
        })
      }
    }, 500),
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    },

    // 完成月度任务
    taskFinish: function () {
      var date = Date.parse(new Date());
      var string = '34f9cd73a0044a2e8d47e85de884b8b1300777';
      var taskid = '117';
      var relation = 'czjl_' + this.dateText;
      var md5 = this.$md5(string + taskid + relation + date);
      var openid = this.getCookie('xmh_openid')

      // 添加记录来源页面
      var sourceFromType = "";
      if (this.$route.query.sourceFrom) {
        switch (this.$route.query.sourceFrom) {
          case 'profile':
            if (this.$route.query.growth == 'true') {
              sourceFromType = '个人中心特权位育儿贴士'
            } else {
              sourceFromType = '个人中心宝宝卡片'
            }

            break;
          case 'homeBaby':
            sourceFromType = '宝宝求关注';
            break;
          case 'signIn':
            sourceFromType = '签到任务';
            break;
          case 'home':
            sourceFromType = '首页成长曲线';
            break;
        }
      }
      var that = this;
      this.$toast({
        message: "保存成功",
        forbidClick: true,
        duration: 2000,
        onClose: function () {
          if (that.sourcState == 1) {
            that.$router.push({
              path: '/parentingTips?source=home',
              query: {
                num: that.babyNum,
                bir: that.dayBith,
                growth: that.growth,
                sourceFrom: that.$route.query.sourceFrom
              }
            });
          } else {
            that.$router.push({
              path: '/growthRecord',
              query: {num: that.babyNum, sourceFrom: that.$route.query.sourceFrom}
            });
          }
        }
      });
      sensors.track('Tool_GrowthRecordPage_AddSuccess_View', {
        GrowthRecordPage_AddSuccess_View_Source: sourceFromType
      })
    },

    // 时间选择器 取消按钮
    closeTime: function () {
      this.dateText = '';
      this.headShow = true
      this.closeTimePicker();
    },
    // 关闭时间选择器
    closeTimePicker: function () {
      $(".timeSelectMask").fadeOut(100);
      $(".timeSelect").fadeOut(100);
    },
    // 弹起时间选择器
    alertTimePicker: function () {
      $(".timeSelectMask").fadeIn(50);
      $(".timeSelect").delay(100).slideDown();
      this.currentDate = new Date()
    },
    confirmTime: function (time) {
      var date = new Date(time);
      this.dateText = this.formatTime(date, "yyyy-MM-dd");
      this.curName = this.dateText;
      var day = this.getDaysBetween(this.babyBir, this.dateText)
      if (day >= 365) {
        this.headShow = false
      } else {
        this.headShow = true
      }
      this.closeTimePicker();
    },
    formatTime: function (date, formatStr) {
      var str = formatStr;
      str = str.replace(/yyyy|YYYY/, date.getFullYear());
      str = str.replace(/MM/, (date.getMonth() + 1) > 9 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1));
      str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
      str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
      str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
      str = str.replace(/ss/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
      return str;
    },
  },
}
</script>
